import { useQuery } from '@tanstack/react-query'

import { ClientInvoiceService } from '@services/client_invoice.service'
import { type APIInvoiceClientDtoResponse, OrderClientDto } from '../types/api'
import { type TInvoiceListOptions, type TQueryConfig } from '../types/general'
import { defaultQueryOptions } from './common'

export const useClientCancelInvoice = (locationName: string, orderId: string, invoiceId: string) => {
  return useQuery<OrderClientDto>({
    queryKey: ['clientCancelInvoice', locationName, orderId, invoiceId],
    queryFn: () => ClientInvoiceService.cancelInvoice(locationName, orderId, invoiceId),
    ...defaultQueryOptions,
    enabled: false,
  })
}

export const useClintInvoiceList = (locationName: string, options: TInvoiceListOptions, config?: TQueryConfig) => {
  const mergedConfig = { enabled: true, ...config }

  return useQuery<APIInvoiceClientDtoResponse>({
    queryKey: ['clientInvoiceList', locationName, options],
    queryFn: () => ClientInvoiceService.getList(locationName, options),
    enabled: mergedConfig.enabled,
    ...defaultQueryOptions,
  })
}
